// extracted by mini-css-extract-plugin
var _1 = "QCTUssbk";
var _2 = "TSslM4yA";
var _3 = "DtrXnZpl";
var _4 = "oJpYrMnV";
var _5 = "jJwr3Lyw";
export { _1 as "btn", _2 as "change", _3 as "difficulty", _4 as "list", _5 as "summary" }
